import { Component, OnInit } from '@angular/core';
import { EventsService } from "src/app/services/events.service";
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'transflo-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrl: './action-buttons.component.scss'
})
export class ActionButtonsComponent implements OnInit {
  isPopupVisible = true;
  eventId: number | null = null;
  confNumber: string | null = null;
  documentMetadata: any[] = [];
  documentName: string = "";
  showPopup: boolean = false;

  fleetId: string | null = null;
  token: string | null = null;

  constructor(
    private eventsService: EventsService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.eventId = params['eventId'] ? +params['eventId'] : null;
      this.confNumber = params['confnumber'] || null;

      this.fleetId = params['fleetId'] || null;
      this.token = params['token'] || null;

      console.log('FleetId:', this.fleetId);
      console.log('Token:', this.token);
    });
  }

  completeAction() {
    if (this.confNumber) {
      if (this.eventId) {
        console.log('Completing action with event ID:', this.eventId);
        const requestBody = { ConfirmationNumber: this.confNumber };
        this.eventsService.CompleteEventWithConfNumber(37/*this.eventId*/, requestBody).subscribe(resp => {
          if (resp && resp.status === 204) {
            console.log('Formatted Response:', JSON.stringify(resp.body, null, 2));
          }
        });
      } else {
        console.error('Event ID is missing!');
      }
    } else {
      console.log('ConfNumber does not exist or is empty');
    }

    this.closePopup();
  }

  redoAction() {
    this.eventsService.getEvent(this.eventId).subscribe(
      (response) => {
        if (response && response.body && response.body.Action && response.body.Action.Document &&
          response.body.Action.Document.MetaData && response.body.Action.Document.MetaData.length > 0) {
          console.log('in if');
          this.documentMetadata = response.body.Action.Document.MetaData;
          this.documentName = response.body.Action.Document.Name;
          this.showPopup = true;
        }
        else if (response && response.body && response.body.Action && response.body.Action.Document &&
          response.body.Action.Document.MetaData && response.body.Action.Document.MetaData.length == 0) {
          const fleetId = localStorage.getItem('fleetId');
          const token = localStorage.getItem('token');
          const appScheme = 'transflomobileplus';
          const sourceApp = 'http://localhost:4200/#/action-buttons';
          let deepLinkUrl = `${appScheme}://scan?recipientid=${fleetId}&return=confnumber&fleetId=${fleetId}&token=${token}&eventId=${this.eventId}&sourceapp=${sourceApp}`;
          console.log('deepLink : ', deepLinkUrl);
          window.location.href = deepLinkUrl;
        }
        else {
          console.log("No documents found for this event.");
          this.eventsService.CompleteEvent(this.eventId).subscribe(resp => {
            if (resp && resp.status === 204) {
              console.log("Formatted Response:", JSON.stringify(resp.body, null, 2));
            }
          });
        }
      },
      (error) => {
        console.error("Error fetching event data", error);
      }
    );
  }

  closePopup() {
    this.isPopupVisible = false;
    //const fleetId = localStorage.getItem('fleetId');
    //const token = localStorage.getItem('token');
    console.log('fleetId: ', this.fleetId);
    console.log('token : ', this.token);
    if (this.fleetId && this.token) {
      this.router.navigate(['/'], { queryParams: { fleetId: this.fleetId, token: this.token } });
    } else {
      console.error('fleetId or token is missing in localStorage!');
    }
    console.log('Popup closed');
  }

  onClosePopup(): void {
    this.showPopup = false;
  }

  onSubmitForm(formData: any): void {
    console.log("Form submitted with data:", formData);
  }
}
